//bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../services/bao-router";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import BaseViewModel from "./../../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
class EventEngineLog extends BaseViewModel {
    CompleteCheck(): boolean | JQueryPromise<boolean> {
        return true;
    }
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.PageIndex.subscribe(() => {
            this.Search();
        });
        this.PageSize.subscribe(() => {
            this.Search();
        });
        this.Sorting.subscribe(() => {
            this.Search();
        });
    }
    Bao = Bao;
    PermissionRefresh: KnockoutObservable<string> = ko.observable("na");
    PermissionSave: KnockoutObservable<string> = ko.observable("na");
    PermissionDelete: KnockoutObservable<string> = ko.observable("na");
    PermissionQRCode: KnockoutObservable<string> = ko.observable("na");
    EventScriptId: KnockoutObservable<string> = ko.observable("");
    EventScriptName: KnockoutObservable<string> = ko.observable("");
    ChecklistId: KnockoutObservable<string> = ko.observable("");
    ChecklistName: KnockoutObservable<string> = ko.observable("");
    EvaluationId: KnockoutObservable<string> = ko.observable("");
    EvaluationName: KnockoutObservable<string> = ko.observable("");
    FromDate: KnockoutObservable<string> = ko.observable("");
    ToDate: KnockoutObservable<string> = ko.observable("");
    EventEngineLogCollection: KnockoutObservableArray<any> = ko.observableArray([]);
    Sorting: KnockoutObservableArray<{
        Column: string;
        Direction: number;
    }> = ko.observableArray([]);
    PageIndex: KnockoutObservable<number> = ko.observable(0);
    PageSize: KnockoutObservable<number> = ko.observable(10);
    TotalRows: KnockoutObservable<number> = ko.observable(0);
    GoToEventScript = () => {
        if (this.EventScriptId() != "") {
            baoRouter.setHash("#checkware/eventscript/" + this.EventScriptId());
        }
    };
    SearcherEventScript: Bindings.baoSearcher = {
        SearchType: "Checkware-EventScript",
        ObjectId: this.EventScriptId,
        ObjectValue: "Name",
        AutoComplete: true,
        AutoSearch: true,
        GotoVisible: Bao.Session.HasPermission('EventScriptSearch', '7A392A95-576D-444F-8375-5FEA08B153CA'),
        Goto: this.GoToEventScript
    };
    GoToChecklist = () => {
        if (this.ChecklistId() != "") {
            baoRouter.setHash("#checkware/template/" + this.ChecklistId());
        }
    };
    SearcherChecklist: Bindings.baoSearcher = {
        SearchType: "Checkware-Checklist",
        ObjectId: this.ChecklistId,
        ObjectValue: "ListName",
        AutoComplete: true,
        AutoSearch: true,
        GotoVisible: Bao.Session.HasPermission('ChecklistSearch', '7A392A95-576D-444F-8375-5FEA08B153CA'),
        Goto: this.GoToChecklist
    };
    GoToEvaluation = () => {
        if (this.EvaluationId() != "") {
            baoRouter.setHash("#checkware/evaluation/" + this.EvaluationId());
        }
    };
    SearcherEvaluation: Bindings.baoSearcher = {
        SearchType: "Checkware-Evaluation",
        ObjectId: this.EvaluationId,
        ObjectValue: "ListName",
        AutoComplete: true,
        AutoSearch: true,
        GotoVisible: Bao.Session.HasPermission('SearchEvaluation', '7A392A95-576D-444F-8375-5FEA08B153CA'),
        Goto: this.GoToEvaluation
    };
    DateTimeBoxFromDate: Bindings.baoDateTimeBox = {
        value: this.FromDate,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DateTimeBoxToDate: Bindings.baoDateTimeBox = {
        value: this.ToDate,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DatePicker: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    Search = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("Checkware/EventEngineLog/Search", JSON.stringify({
            eventScriptId: this.EventScriptId(),
            checklistId: this.ChecklistId(),
            evaluationId: this.EvaluationId(),
            fromDate: this.FromDate(),
            ToDate: this.ToDate(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        })).done((result: {
            Models: any;
            TotalRows: number;
        }) => {
            this.TotalRows(0);
            this.EventEngineLogCollection([]);
            if (result != null && result.Models != null) {
                this.EventEngineLogCollection(result.Models);
                this.TotalRows(result.TotalRows);
            }
            this.TabPage.IsLoading(false);
        });
    };
    InitUrl() {
        return "";
    }
    init() {
        return $.when(super.init(), this.loadMetaData());
    }
    loadMetaData() {
        return Bao.post("Checkware/EventEngineLog/EventEngineLogMetaData")
            .done((result: {
            TabTitle: string;
        }) => {
            this.TabPage.Title(result.TabTitle);
        });
    }
    // override to avoid this.unlockurl-call
    BeforeClose(closeFn) {
        return closeFn();
    }
}
export default EventEngineLog;